const _arrival_state = {
	items: [],
	pag_items: [],
	date: ''
}

function arrivalUpdateDataset(liNode, datasetName, value) {
	liNode.dataset[datasetName] = value
}

// checkbox on/off
function arrivalCheckboxHandler(liNode, active) {
	const checkbox = liNode.querySelector('[type="checkbox"]'),
		inputCounter = liNode.querySelector('.Counter__input')

	checkbox.checked = active

	if (active && !Number(inputCounter.value)) {
		inputCounter.value = 1
	} else if (!active) {
		inputCounter.value = 0
	}

	liNode.setAttribute('arrival-selected', active)

	arrivalUpdateDataset(liNode, 'quantity', Number(inputCounter.value))
	arrivalValidation()
}

function arrivalValidation() {
	const parentNodes = document.querySelectorAll('.popup-arrival')

	// reset arrival state
	_arrival_state.items = []
	_arrival_state.pag_items = []

	for (const parentNode of parentNodes) {
		const liNodes = parentNode.querySelectorAll('li.item-popup-arrival')

		for (const liNode of liNodes) {
			if (liNode.getAttribute('arrival-selected') === 'true') {
				if (liNode.closest('#popup-arrival-pag')) {
					_arrival_state.pag_items.push({ ...liNode.dataset })
				} else {
					_arrival_state.items.push({ ...liNode.dataset })
				}
			}
		}
	}

	submitButtonHandler()
}

function submitButtonHandler() {
	const parentNode = document.querySelector('#popup-arrival-pag')
	const submitButton = parentNode.querySelector('.Button--submit')

	if (_arrival_state.items.length || _arrival_state.pag_items.length) {
		submitButton.removeAttribute('disabled')
	} else {
		submitButton.setAttribute('disabled', '')
	}
}

function arrivalSendOrder(button) {
	const parentNode = button.closest('.popup-arrival')
	const URL = parentNode.dataset.path

	// для дальнейшей проверки отправился ли запрос корректно
	let ok = false

	// Получаем дату выбранную в блоке на странице
	{
		const parentNode = document.querySelector('.Product-description__arrival')
		_arrival_state.date = parentNode.dataset.date
	}

	const request = fetch(URL, {
		method: 'POST',
		body: JSON.stringify(_arrival_state)
	}).then(response => response.json())

	request.then((data) => {
		ok = arrivalInfoWindow(data)
	})

	request.catch(() => arrivalInfoWindow({ status: 'error', title: 'Ошибка!', text: 'Заказ не сформирован, попробуйте ещё раз' }))

	request.finally(() => {
		setTimeout(() => {
			$.fancybox.destroy()

			if (ok) {
				location.href = '/cabinet/order/'
			}
		}, 500)
	})
}

function arrivalInfoWindow(response) {
	const parentNode = document.querySelector('.popup-success-res')

	const fieldNodes = {
		title: parentNode.querySelector('[data-title]'),
		text: parentNode.querySelector('[data-text]'),
	}

	if (response.status === 'success') {
		parentNode.classList.remove('res-error')
		parentNode.classList.add('res-success')
	} else {
		parentNode.classList.remove('res-success')
		parentNode.classList.add('res-error')
	}

	fieldNodes.title.textContent = response.title
	fieldNodes.text.textContent = response.text

	$.fancybox.open(parentNode)

	return response.status === 'success'
}